import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "content"]
  static values = { clearInputs: Boolean }

  connect() {
    if (this.hasTriggerTarget) {
      this.toggle()
    }
  }

  toggle() {
    if (!this.hasTriggerTarget) return

    // For radio buttons, find the checked one
    const checkedRadio = this.triggerTargets.find(target => target.checked)
    if (!checkedRadio) {
      // No radio selected, hide all content
      this.contentTargets.forEach(content => {
        content.classList.add("d-none")
      })
      return
    }

    let triggerValue = checkedRadio.value

    this.contentTargets.forEach(content => {
      // Several values, space-separated: the content shows for any of them.
      const contentValues = (content.dataset.conditionalDisplayValue || "").split(" ")

      if (contentValues.includes(triggerValue)) {
        content.classList.remove("d-none")
      } else {
        content.classList.add("d-none")
        if (this.clearInputsValue) {
          content.querySelectorAll('input[type="radio"]').forEach(radio => {
            radio.checked = false
          })
        }
      }
    })
  }
}
